<!-- Sidebar -->
<c-sidebar #sidebar="cSidebar" id="sidebar" class="d-print-none sidebar sidebar-dark sidebar-fixed" visible>
  <c-sidebar-brand [brandFull]="{
      src: 'assets/img/bms-logo.webp',
      height: 50,
      alt: 'BMS Road Tax'
    }" [brandNarrow]="{
      src: 'assets/img/bms-logo.webp',
      height: 35,
      alt: 'BMS Road Tax'
    }" routerLink="/dashboard">
  </c-sidebar-brand>
  <c-sidebar-nav [navItems]="navItems" dropdownMode="close"></c-sidebar-nav>
  @if (!sidebar.narrow) {
    <c-sidebar-footer cSidebarToggle="sidebar" class="border-top d-none d-lg-flex" toggle="unfoldable"
      style="cursor: pointer;">
      <button cSidebarToggler aria-label="Toggle sidebar fold"></button>
    </c-sidebar-footer>
  }
</c-sidebar>

<!-- Main wrapper -->
<div class="wrapper d-flex flex-column min-vh-100">
  <!-- Header -->
  <app-default-header position="sticky" class="mb-4 d-print-none p-0" sidebarId="sidebar"></app-default-header>

  <!-- Main content -->
  <div class="body flex-grow-1">
    <main class="container-fluid h-auto px-4">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Footer -->
  <app-default-footer></app-default-footer>
</div>
